export const CloseSmRedIcon = ({
  strokeColor = "var(--color-red)",
  ...props
}: any) => (
  <svg {...props} width="15" height="16" viewBox="0 0 15 16" fill="none">
    <g id="Icons All" clipPath="url(#clip0_2485_52890)">
      <path
        id="Vector"
        d="M2.74559 4.02199L11.5844 12.8608M2.74559 12.8608L11.5844 4.02199"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2485_52890">
        <rect
          width="15"
          height="15"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
